import { deleteApi, getApi, putApiWithoutId } from "../../Shared/Services/RestService";
import {
  SeoPageConfig,
  SeoPageConfigRequest,
  SeoPublicConfig,
  SeoSiteSettings,
} from "../Types/SeoType";

/**
 * The public SEO payload. The same endpoint the frontend reads on every page load.
 */
export const getSeoPublicConfig = () => getApi<SeoPublicConfig>("/seo/config");

/**
 * The page list with the admin overrides applied. Behind the SETTINGS_UPDATE privilege.
 */
export const getSeoPageConfigs = () => getApi<SeoPageConfig[]>("/seo/config/pages");

/**
 * Creates the page when the key is new and updates it when it already exists.
 */
export const saveSeoPageConfig = (payload: SeoPageConfigRequest) =>
  putApiWithoutId<SeoPageConfig>("/seo/config/pages", payload);

/**
 * Drops the override so the page falls back to its seeded defaults.
 */
export const resetSeoPageConfig = (pageKey: string) =>
  deleteApi<{ deleted: boolean }>("/seo/config/pages", pageKey);

export const updateSeoSiteSettings = (payload: SeoSiteSettings) =>
  putApiWithoutId<SeoSiteSettings>("/seo/config/site", payload);
